import { useNavigate } from "react-router-dom";
import DashboardItems from "./DashboardComponents/DashboardItems";

import { isTeacher } from "../../hooks/utils";
import { useAppSelector } from "../../store/hooks";
import Animation from "../Animation";
import Spinner from "../Spinner";

const DashItemWrapper = ({ children, activeItem }) => {
  const { user } = useAppSelector((state) => state.store);

  const navigate = useNavigate();

  if (!user)
    return (
      <div className="d-flex justify-content-center m-3">
        <Spinner />
      </div>
    );

  if (!isTeacher()) navigate("/");

  return (
    <Animation>
      <div className="container mx-auto flex flex-col md:flex-row pt-12 gap-6 md:pb-8 pb-4">
        {/* Sidebar */}
        <div className="flex flex-col flex-grow min-h-[90vh] w-full md:w-1/4 bg-primary px-2 rounded-xl overflow-hidden">
          <h4 className="py-3 mx-3 text-2xl text-white border-b border-b-white">لوحة التحكم</h4>
          <div className="w-full text-white bg-transparent ps-0 pe-2 border-0">
            <div className="w-full bg-transparent px-2">
              <div className="w-full bg-transparent px-2 text-right">
                <DashboardItems activeItem={activeItem} />
              </div>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="flex-grow md:w-10/12 md:max-w-3/4">
          <div className="w-full">{children}</div>
        </div>
      </div>
    </Animation>
  );
};

export default DashItemWrapper;
